import React from "react";
import Container from "@material-ui/core/Container";
import Breadcrumb from "../common/breadcum";
import Grid from "@material-ui/core/Grid";
import ThemeContainer from "../common/ThemeProvider";
import { useSnackbar } from "notistack";
import Dropzone from "react-dropzone-uploader";
import { Paper } from "@material-ui/core";
import "react-dropzone-uploader/dist/styles.css";
//import styled from "styled-components";

const DropzoneMainInforme2 = (props) => {
  const projectSlug = props.match.params.slug;

  //SERVIDOR
  const info =
    "http://cimogsys.espoch.edu.ec/api-sgi/public/storage/projects/" +
    props.location.state.informe;
  //LOCAL
  /*const info =
    "http://localhost/apispirit/public/storage/projects/" +
    props.location.state.informe;*/
  let valor;
  let nombre;

  const i1 = props.location.state.i.informe1;
  const i2 = props.location.state.i.informe2;
  const i3 = props.location.state.i.informe3;
  const i4 = props.location.state.i.informe4;
  const i5 = props.location.state.i.informe5;
  const i6 = props.location.state.i.informe6;
  const i7 = props.location.state.i.informe7;
  const i8 = props.location.state.i.informe8;
  const i9 = props.location.state.i.informe9;
  const i10 = props.location.state.i.informe10;

  const resol = () => {
    if (i1 === info) valor = 1;
    if (i2 === info) valor = 2;
    if (i3 === info) valor = 3;
    if (i4 === info) valor = 4;
    if (i5 === info) valor = 5;
    if (i6 === info) valor = 6;
    if (i7 === info) valor = 7;
    if (i8 === info) valor = 8;
    if (i9 === info) valor = 9;
    if (i10 === info) valor = 10;
    return valor;
  };

  const apiEndPoint = process.env.REACT_APP_API_URL;
  const { enqueueSnackbar } = useSnackbar();

  const styles = {
    dropzone: { width: "23em", height: "12em" },
    dropzoneActive: {
      borderColor: "blue",
      inputContent: "Soltar el archivo",
    },
    inputLabel: {
      color: "#00aae4",
      fontFamily: "Tahoma",
      fontSize: "11px",
    },
  };

  const getUploadParams = ({ meta }) => {
    return {
      url: `${apiEndPoint}/projects/${projectSlug}/informe2${valor}`,
    };
  };

  const handleChangeStatusR = (
    { meta, remove, file },
    status,
    fileWithMeta
  ) => {
    resol();
    if (status === "done") {
      enqueueSnackbar(`${meta.name} fue subido correctamente!`, {
        variant: "success",
      });
      nombre = JSON.parse(fileWithMeta[0].xhr.response);
      remove();
    } else if (status === "aborted") {
      enqueueSnackbar(
        `${meta.name} no se subió! Detalle: ${fileWithMeta[0].xhr.response}`,
        { variant: "error" }
      );
    } else if (status === "error_file_size") {
      enqueueSnackbar(`Error! Detalle: Tamaño máximo permitido es 2MB.`, {
        variant: "error",
      });
    } else if (status === "error_upload") {
      enqueueSnackbar(
        `Error! Detalle: Tamaño máximo permitido es 2MB y debe ser PDF.`,
        { variant: "error" }
      );
    } else if (status === "rejected_file_type") {
      enqueueSnackbar(
        `${meta.name} no se subió! Detalle: Solo se aceptan archivos en formato PDF`,
        { variant: "error" }
      );
    }
  };

  const listBreadcrumbs = [
    {
      path: `/proyecto/` + props.match.params.slug + `/`,
      label: props.match.params.slug.toUpperCase(),
      state: {
        r: projectSlug,
      },
    },
  ];

  return (
    <Container maxWidth="md" id="projectMain">
      <Breadcrumb
        onListBreadcrumbs={listBreadcrumbs}
        lastLabel={`Informe Semestral (Agosto - Diciembre) `}
      />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <ThemeContainer>
            <Paper className="paper">
              <h2>Informe Semestral (Agosto - Diciembre): </h2>
              <Dropzone
                getUploadParams={getUploadParams}
                onChangeStatus={handleChangeStatusR}
                autoUpload={false}
                maxFiles={1}
                multiple={false}
                canCancel={false}
                styles={styles}
                onchange="alert(this.value)"
                inputContent="Arrastrar aquí el PDF para subirlo"
                maxSizeBytes={20000000} // 20MB
                accept="application/pdf"
                //acceptedFiles = ".zip, .pdf"
              />
            </Paper>
          </ThemeContainer>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DropzoneMainInforme2;
